import styled from '@emotion/styled'

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  gap: 2rem;
  padding: 2rem 0;
  max-width: 1440px;
  width: 100%;

  @media (max-width: 768px) {
    padding: 2rem;
  }
`
